// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from 'react-query'

import { submitTemplate } from '@/services/templates'
import { queryKey as getTemplatesQueryKey } from './useGetTemplates'

export const useUploadTemplate = (): UseMutationResult<string, Error, File> => {
  const queryClient = useQueryClient()

  return useMutation((file) => submitTemplate(file), {
    onSuccess: async () => {
      await queryClient.invalidateQueries(getTemplatesQueryKey)
    },
  })
}
